import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./PaginationPage.styled";
export const PaginationPage = forwardRef((props, ref) => {
    const { ariaLabel, arrow, children, hasBorders, href, isActive, isDisabled, label, linkComponent, onPageClick = () => { }, pageObject, size, target, value, ...otherProps } = props;
    /* Background color for isActive is interactiveConstructive but text always needs to be structural */
    const paginationPageContent = () => {
        if (children) {
            return children;
        }
        // TODO wtf?
        // return <span palette="structural">{label}</span>;
        return _jsx("span", { children: label });
    };
    const as = !isDisabled && linkComponent ? linkComponent : !isDisabled && href ? "a" : "button";
    // TODO check prop spread on this
    return (_jsx(Styled.PaginationPage, { ref: ref, "data-testid": "PaginationPage", arrow: arrow, hasBorders: hasBorders, size: size, ...otherProps, children: _jsx(Styled.PaginationPageContent, { as: as, palette: isActive ? "interactiveConstructive" : "structural", isActive: isActive, "aria-label": ariaLabel, "aria-disabled": isDisabled || isActive, arrow: arrow, isDisabled: isDisabled || isActive, href: href, onClick: (event) => {
                if (isDisabled) {
                    event.preventDefault();
                    return;
                }
                event.persist();
                onPageClick(pageObject || {}, event);
            }, target: target, tabIndex: isDisabled || isActive ? -1 : 0, value: value, size: size, children: paginationPageContent() }) }));
});
PaginationPage.displayName = "PaginationPage";
PaginationPage.defaultProps = {
    ariaLabel: "",
    isActive: false,
    isDisabled: false,
    label: "",
    onPageClick: () => { },
    size: "large",
    value: "",
    hasBorders: false
};
